import React from "react";
interface IconProps {
	fill: string;
	class?: string;
	className?: string;
	height: number;
}


export const EcoFlexIcon = (props: IconProps) => (
	<svg fill={props.fill} className={props.class} viewBox="0 0 270.873 270.873" width={props.height} height={props.height} >
		<g>
		<path d="M51.302,60.061c-1.879,2.168-1.643,5.454,0.526,7.335c0.982,0.853,2.194,1.27,3.399,1.27c1.455,0,2.907-0.609,3.931-1.792
			c0.807-0.932,19.563-22.968,5.342-40.867c-7.889-9.931-2.059-15.704-0.792-16.78c2.207-1.793,2.564-5.038,0.787-7.27
			c-1.79-2.244-5.06-2.61-7.307-0.825c-5.449,4.342-12.642,16.479-0.833,31.344C65.21,43.613,51.437,59.903,51.302,60.061z"/>
		<path d="M96.801,60.061c-1.879,2.168-1.643,5.454,0.525,7.335c0.982,0.853,2.194,1.27,3.4,1.27c1.455,0,2.907-0.609,3.93-1.792
			c0.808-0.932,19.563-22.968,5.342-40.867c-7.889-9.931-2.059-15.704-0.792-16.78c2.207-1.793,2.564-5.038,0.787-7.27
			c-1.79-2.244-5.06-2.61-7.307-0.825c-5.449,4.342-12.642,16.479-0.833,31.344C110.709,43.613,96.935,59.903,96.801,60.061z"/>
		<path d="M142.299,60.061c-1.879,2.168-1.643,5.454,0.526,7.335c0.982,0.853,2.196,1.27,3.399,1.27c1.457,0,2.91-0.609,3.931-1.792
			c0.807-0.932,19.565-22.968,5.342-40.867c-7.886-9.931-2.057-15.704-0.792-16.78c2.209-1.793,2.564-5.038,0.787-7.27
			c-1.788-2.244-5.058-2.61-7.308-0.825c-5.448,4.342-12.642,16.479-0.833,31.344C156.208,43.613,142.434,59.903,142.299,60.061z"/>
		<path d="M187.798,60.061c-1.879,2.168-1.646,5.454,0.528,7.335c0.98,0.853,2.193,1.27,3.397,1.27c1.457,0,2.909-0.609,3.93-1.792
			c0.808-0.932,19.565-22.968,5.343-40.867c-7.887-9.931-2.057-15.704-0.793-16.78c2.209-1.793,2.564-5.038,0.787-7.27
			c-1.787-2.244-5.058-2.61-7.307-0.825c-5.449,4.342-12.64,16.479-0.833,31.344C201.707,43.613,187.93,59.903,187.798,60.061z"/>
		<path d="M39.023,270.873c8.617,0,15.6-6.982,15.6-15.6V103.379c0-8.615-6.982-15.6-15.6-15.6c-8.615,0-15.6,6.984-15.6,15.6
			v151.895C23.424,263.886,30.409,270.873,39.023,270.873z"/>
		<path d="M58.955,103.155V255.05c0,8.618,6.985,15.6,15.599,15.6c8.618,0,15.6-6.981,15.6-15.6V103.155
			c0-8.615-6.982-15.6-15.6-15.6C65.939,87.556,58.955,94.54,58.955,103.155z"/>
		<path d="M110.09,270.426c8.617,0,15.6-6.981,15.6-15.599V102.932c0-8.615-6.982-15.6-15.6-15.6c-8.615,0-15.6,6.985-15.6,15.6
			v151.896C94.49,263.439,101.475,270.426,110.09,270.426z"/>
		<path d="M145.62,270.203c8.617,0,15.6-6.982,15.6-15.6V102.708c0-8.614-6.982-15.599-15.6-15.599c-8.615,0-15.6,6.985-15.6,15.599
			v151.896C130.021,263.221,137.005,270.203,145.62,270.203z"/>
		<path d="M181.156,269.979c8.617,0,15.6-6.982,15.6-15.6V102.485c0-8.615-6.982-15.6-15.6-15.6c-8.612,0-15.6,6.985-15.6,15.6
			V254.38C165.557,262.997,172.544,269.979,181.156,269.979z"/>
		<path d="M201.087,102.262v151.895c0,8.617,6.982,15.6,15.6,15.6s15.6-6.982,15.6-15.6V152.932h2.382
			c7.059,0,12.781-8.922,12.781-19.933c0-11.009-5.723-19.931-12.781-19.931c-0.812,0-1.605,0-2.382,0v-10.806
			c0-8.615-6.982-15.6-15.6-15.6S201.087,93.652,201.087,102.262z"/>
	
		</g>

	</svg >
)


// WEBPACK FOOTER //
// ./src/layout/icons/EcoFlex.tsx